import cyjAccess from './cyj-access.vue'

export default cyjAccess
